module.exports = __webpack_public_path__ + "static/media/boutique.1ba5887b.jpg";